import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as moment from 'moment';
import { DateRange } from '../date-range';
import { HttpService } from '../service/http.service';
import { PaymentReceivedWithBooking } from '../payment-received-with-booking';
import { ToastMessageService } from '../toast-message.service';

@Component({
  selector: 'app-payments-received',
  templateUrl: './payments-received.component.html',
  styleUrls: ['./payments-received.component.css']
})
export class PaymentsReceivedComponent implements OnInit {

  payments: PaymentReceivedWithBooking[] = [];
  searchForm!: FormGroup;
  yearRange = "2000:" + moment().year();

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ) { }

  ngOnInit(): void {
    let today = moment();
    let oldDate = today.subtract(2, "years");
    this.httpService.getPaymentsReceivedByRange(new DateRange(oldDate, today)).subscribe(res => {
      this.payments = res;
    });
    this.searchForm = this.builder.group({
      from: [null, Validators.required],
      to: [null, Validators.required]
    });
  }

  searchByRange(){
    let range = new DateRange(
      moment(this.searchForm.value.from).utc(true),
      moment(this.searchForm.value.to).utc(true)
    );
    if(range.from.isAfter(range.to)){
      this.toastService.addError("Error", "'from' date should be before 'to' date");
      return;
    }
    this.httpService.getPaymentsReceivedByRange(range).subscribe(res => {
      this.payments = res;
    });
  }

  
  makeReport() {
    console.log(this.payments);
    let csv = "ID;" +
      "First name;" +
      "Last name;" +
      "Start date;" +
      "End date;" +
      "Destination;" +
      "Comment;" +
      "EU/Exportation;" +
      "Amount;" +
      "Currency;" + 
      "Paid date;" + 
      "Invoice;" +
      "\n";

    for (let payment of this.payments) {
      let euOrExportation = payment.isEuForVat?"EU":"Exportation";
      csv +=
        payment.bookingId + ";" +
        payment.studentFirstName + ";" +
        payment.studentLastName + ";" +
        payment.startDate.format("DD/MM/YYYY") + ";" +
        payment.endDate.format("DD/MM/YYYY") + ";" +
        payment.destinationName + ";" + 
        payment.comment + ";" +
        euOrExportation + ";" +
        payment.amount + ";" + 
        payment.currency.isoCode + ";" + 
        payment.date.format("DD/MM/YYYY") + ";" +
        payment.invoiceNumber + ";" +
        "\n";
    }
   
    let link = document.createElement("a");
    link.href = "data:application/octet-stream;charset=utf8,%EF%BB%BF" + encodeURI(csv);
    link.download = "report.csv";
    link.target = "_blank";
    link.click();
    link.remove();
  }

}
